/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconClockX = createReactComponent("outline", "clock-x", "IconClockX", [["path", { "d": "M20.926 13.15a9 9 0 1 0 -7.835 7.784", "key": "svg-0" }], ["path", { "d": "M12 7v5l2 2", "key": "svg-1" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-2" }], ["path", { "d": "M17 22l5 -5", "key": "svg-3" }]]);

export { IconClockX as default };
//# sourceMappingURL=IconClockX.mjs.map
